<header>
  <h3 class="d-flex justify-content-center align-items-center" style="color: #00A99D;">
    {{title | titlecase}}...
  </h3>
</header>
<main>
  <div class="d-flex justify-content-center align-items-center mt-3">
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
</main>
